<div class="alert alert-{{type}} alert-dismissible fade show" role="alert">
  <ng-content></ng-content>
  <button type="button" class="btn-close" data-bs-dismiss="alert" (click)="close.emit()"></button>
</div>
